###
Binds file as a new model property on change event
Allows to use file input with ng-model
# Usage
	<input
		wm-input-file
		type="file"
		bind-to="model.required"
		bind-name-to="model.optional"
	/>
###
angular
	.module 'App.Directive'
	.directive 'wmInputFile', ($timeout) ->
		restrict: 'A'
		scope:
			bindTo: '='
			bindNameTo: '=?'
			onChange: '&?'
		link: (scope, element) ->
			element.bind 'change', ($event) ->
				scope.$apply ->
					scope.bindTo = $event.target.files[0]

					if angular.isDefined scope.bindNameTo
						scope.bindNameTo = scope.bindTo.name

					if scope.onChange?
						$timeout(
							-> scope.onChange({file: $event.target.files[0]})
						)
